import React from 'react';


import Styles from './Styles.module.scss';
import PrivacyView from '../anonymous/legal/PrivacyView.jsx';

class PrivacyPolicy extends React.Component {

    componentDidMount() {
    }

    render() {
        return (
            <div className={ Styles.rightContent }>
                <PrivacyView />
            </div>
        )
    }
}

export default PrivacyPolicy;